<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="7" viewBox="0 0 6 7" fill="none">
    <circle cx="3" cy="3.5" r="3" fill="currentColor" />
  </svg>
</template>
